import { useCallback, useState } from 'react';
import { fetchUserRolesFromDb, type UserRole } from '../services/userService';
import { getErrorMessage } from '../utils/errors';

export function useUserRoles() {
    const [roles,   setRoles]   = useState<UserRole[]>([]);
    const [loading, setLoading] = useState(false);
    const [error,   setError]   = useState<string | null>(null);

    const fetchRoles = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await fetchUserRolesFromDb();
            setRoles(data);
        } catch (err) {
            setError(getErrorMessage(err, 'Failed to load user roles'));
        } finally {
            setLoading(false);
        }
    }, []);

    return { roles, loading, error, fetchRoles };
}